import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { headlineExamples } from "@/mocks/guide";

export default function HeadlineLab() {
  return (
    <section className="w-full bg-foreground-950 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full">
        <SectionHeading
          light
          align="center"
          eyebrow="投稿标题技巧"
          title="同一个选题，标题换一种写法，点击率就翻倍"
          desc="下面三组对比来自真实投稿。左边是常见的平庸写法，右边是我们帮作者改过的版本。差别不在文采，而在于有没有把关键细节提前。"
        />

        <div className="mt-12 space-y-5">
          {headlineExamples.map((item, index) => (
            <Reveal key={item.after} delay={index * 100}>
              <div className="grid grid-cols-1 gap-4 rounded-lg border border-background-100/10 bg-background-50/[0.04] p-5 md:grid-cols-12 md:items-center md:gap-6 md:p-6">
                <div className="md:col-span-11">
                  <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                    <div className="rounded-md border border-background-100/10 bg-background-50/[0.03] p-4">
                      <p className="flex items-center gap-1.5 text-[11px] font-medium tracking-wide text-foreground-400">
                        <i className="ri-close-circle-line text-sm leading-none"></i>
                        平庸标题
                      </p>
                      <p className="mt-2 text-sm leading-snug text-background-200/70 line-through decoration-foreground-600">
                        {item.before}
                      </p>
                    </div>
                    <div className="rounded-md border border-accent-500/30 bg-accent-500/10 p-4">
                      <p className="flex items-center gap-1.5 text-[11px] font-medium tracking-wide text-accent-400">
                        <i className="ri-checkbox-circle-line text-sm leading-none"></i>
                        爆款标题
                      </p>
                      <p className="mt-2 font-heading text-base font-semibold leading-snug text-background-50">
                        {item.after}
                      </p>
                    </div>
                  </div>
                  <p className="mt-3.5 text-xs leading-relaxed text-background-200/60">
                    <span className="text-accent-400">改动要点：</span>
                    {item.reason}
                  </p>
                </div>
                <div className="flex items-center justify-center md:col-span-1">
                  <span className="font-heading text-2xl font-bold text-background-100/25">
                    0{index + 1}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-background-200/60">
          更多标题写法与编辑偏好，见
          <Link to="/guide" className="ml-1 text-accent-400 underline underline-offset-4 cursor-pointer">
            投稿指南
          </Link>
        </p>
      </div>
    </section>
  );
}